/* SEO + GEO layer: page titles, meta descriptions, canonical URLs, Open Graph and
   schema.org JSON-LD. Pages are prerendered, so everything written here ends up
   in the static HTML that search engines and AI crawlers read. Safe to re-run. */
(function () {
  // Production domain. Update if the site launches on a different domain.
  const SITE = 'https://lechicbeauty.com/';
  const BRAND = 'Le Chic Beauty';
  const EMAIL = 'hello@lechichair.com';
  LC.SITE = SITE;
  LC.BRAND = BRAND;
  LC.EMAIL = EMAIL;

  LC.abs = (path) => {
    const clean = String(path || '').replace(/^\.?\//, '').replace(/^index\.html$/, '');
    return new URL(clean, SITE).href;
  };

  LC.orgLd = {
    '@type': 'Organization',
    '@id': `${SITE}#organization`,
    name: BRAND,
    alternateName: ['Le Chic Hair', 'LeChic Hair', 'Le Chic Hair Tools', 'Le Chic Beauty Tools'],
    url: SITE,
    email: EMAIL,
    description: 'Le Chic Beauty makes professional hair styling tools with far infrared and negative ion technology, Repairing Caviar hair care, and 100% Remy human hair halo and clip-in extensions. Registered hair tools are covered by a Limited Lifetime Warranty.',
    contactPoint: { '@type': 'ContactPoint', contactType: 'customer service', email: EMAIL, availableLanguage: 'English' },
    brand: { '@type': 'Brand', name: BRAND }
  };

  const websiteLd = {
    '@type': 'WebSite',
    '@id': `${SITE}#website`,
    url: SITE,
    name: BRAND,
    publisher: { '@id': `${SITE}#organization` },
    inLanguage: 'en-US'
  };

  function setMeta(attr, key, content) {
    if (content == null || content === '') return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  }

  function setLink(rel, href) {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
      el = document.createElement('link');
      el.setAttribute('rel', rel);
      document.head.appendChild(el);
    }
    el.setAttribute('href', href);
  }

  const clip = (s, max) => {
    const t = String(s || '').replace(/\s+/g, ' ').trim();
    if (t.length <= max) return t;
    return t.slice(0, t.lastIndexOf(' ', max - 1)).replace(/[,;:\s]+$/, '') + '…';
  };
  LC.clip = clip;

  /**
   * Apply page-level SEO.
   * @param {{title:string, description:string, path:string, image?:string, type?:string, jsonld?:object[], noindex?:boolean}} o
   */
  LC.seo = function (o) {
    const url = LC.abs(o.path);
    const description = clip(o.description, 158);
    const image = o.image ? LC.abs(o.image) : LC.abs('images/h-1.jpg');

    document.title = o.title;
    document.documentElement.setAttribute('lang', 'en');
    setMeta('name', 'description', description);
    setMeta('name', 'robots', o.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setLink('canonical', url);

    setMeta('property', 'og:site_name', BRAND);
    setMeta('property', 'og:locale', 'en_US');
    setMeta('property', 'og:type', o.type || 'website');
    setMeta('property', 'og:title', o.title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', image);
    setMeta('property', 'og:image:alt', o.imageAlt || o.title);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', o.title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', image);

    document.head.querySelectorAll('script[type="application/ld+json"]').forEach((s) => s.remove());
    const graph = [LC.orgLd, websiteLd, ...(o.jsonld || [])].filter(Boolean);
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph });
    document.head.appendChild(script);
  };

  /* ---------- JSON-LD builders ---------- */
  LC.webPageLd = (type, path, name, description, extra = {}) => Object.assign({
    '@type': type,
    '@id': `${LC.abs(path)}#webpage`,
    url: LC.abs(path),
    name,
    description: clip(description, 300),
    isPartOf: { '@id': `${SITE}#website` },
    publisher: { '@id': `${SITE}#organization` },
    inLanguage: 'en-US'
  }, extra);

  LC.breadcrumbLd = (items) => ({
    '@type': 'BreadcrumbList',
    itemListElement: items.map(([name, path], i) => ({ '@type': 'ListItem', position: i + 1, name, item: LC.abs(path) }))
  });

  LC.faqLd = (faqs, path) => (faqs && faqs.length ? {
    '@type': 'FAQPage',
    '@id': `${LC.abs(path)}#faq`,
    mainEntity: faqs.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } }))
  } : null);

  LC.itemListLd = (products, path, name) => ({
    '@type': 'ItemList',
    '@id': `${LC.abs(path)}#products`,
    name,
    numberOfItems: products.length,
    itemListElement: products.map((p, i) => ({ '@type': 'ListItem', position: i + 1, url: LC.abs(LC.productUrl(p.id)), name: p.name }))
  });

  LC.howToLd = (name, description, steps, path, image) => (steps && steps.length ? {
    '@type': 'HowTo',
    '@id': `${LC.abs(path)}#howto`,
    name,
    description: clip(description, 300),
    image: image ? LC.abs(image) : undefined,
    step: steps.map((s, i) => ({
      '@type': 'HowToStep',
      position: i + 1,
      name: s.name || `Step ${i + 1}`,
      text: s.text
    }))
  } : null);

  const returnPolicy = {
    '@type': 'MerchantReturnPolicy',
    applicableCountry: 'US',
    returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
    merchantReturnDays: 14,
    returnFees: 'https://schema.org/ReturnShippingFees',
    returnMethod: 'https://schema.org/ReturnByMail'
  };

  LC.productLd = (p, path) => {
    const url = LC.abs(path);
    const images = (p.images.length ? p.images : [LC.productImage(p)]).map((i) => LC.abs(i.src));
    const offer = p.price != null ? {
      '@type': 'Offer',
      url,
      price: p.price.toFixed(2),
      priceCurrency: 'USD',
      itemCondition: 'https://schema.org/NewCondition',
      seller: { '@id': `${SITE}#organization` },
      hasMerchantReturnPolicy: returnPolicy
    } : undefined;
    const props = p.features.map((f) => ({ '@type': 'PropertyValue', name: 'Feature', value: f }));
    const base = {
      name: p.name,
      description: clip(p.description, 500),
      image: images,
      brand: { '@type': 'Brand', name: BRAND },
      manufacturer: { '@id': `${SITE}#organization` },
      category: LC.collections[p.category] ? LC.collections[p.category].name : undefined,
      url,
      additionalProperty: props.length ? props : undefined
    };

    if (p.options.length > 1) {
      return {
        '@type': 'ProductGroup',
        '@id': `${url}#product`,
        ...base,
        productGroupID: p.id,
        variesBy: ['https://schema.org/color'],
        hasVariant: p.options.map((o) => ({
          '@type': 'Product',
          name: `${p.name} – ${o.name}`,
          sku: o.sku || undefined,
          color: o.name,
          image: o.image ? LC.abs(o.image) : images[0],
          brand: { '@type': 'Brand', name: BRAND },
          offers: offer
        }))
      };
    }
    return {
      '@type': 'Product',
      '@id': `${url}#product`,
      ...base,
      sku: p.sku || (p.options[0] && p.options[0].sku) || undefined,
      offers: offer
    };
  };

  LC.articleLd = (a, path) => ({
    '@type': 'BlogPosting',
    '@id': `${LC.abs(path)}#article`,
    headline: a.title,
    description: a.excerpt,
    image: LC.abs(a.cover),
    datePublished: a.date,
    dateModified: a.date,
    articleSection: a.category,
    wordCount: String(a.body || '').replace(/<[^>]+>/g, ' ').split(/\s+/).filter(Boolean).length,
    author: { '@id': `${SITE}#organization` },
    publisher: { '@id': `${SITE}#organization` },
    mainEntityOfPage: { '@id': `${LC.abs(path)}#webpage` },
    inLanguage: 'en-US'
  });
})();
